import React, {useEffect, useState} from 'react';
import {DebounceInput} from 'react-debounce-input';
import gridIcon from './../assets/images/grid-view.svg';
import listIcon from './../assets/images/list-view.svg';
import 'rsuite/dist/styles/rsuite-default.css';
import firebase, { storageRef, imagebankRef } from '../firebase.js';
import NewBrandForm from './admin/NewBrandForm';
import { DateRangePicker, SelectPicker, IconButton, Icon, Alert, Modal, List, FlexboxGrid, Button, InputGroup, Input } from 'rsuite';
const { afterToday } = DateRangePicker;


export default class SearchForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: null,
      view: "grid",
      sort: "date"
    };
  }
  handleChange = (evt) => {
    let search = this.props.search
    search.term = evt.target.value;
    this.props.doSearch(search);
    //this.setState({search});
  };
  handleFilterChange = (filter) => {
    let search = this.props.search
    Object.keys(search.filters).forEach(k => { if(k !== filter) search.filters[k] = false });
    search.filters[filter] = !search.filters[filter];
    this.props.doSearch(search);
    //this.setState({search});
  };
  handleSelectChange = selectedOption => {
    let search = this.props.search
    const selectedValue = selectedOption ? selectedOption : "";
    search.country = selectedValue;
    //this.setState({selectedOption});
    this.props.doSearch(search);
  };
  handleDateChange = dates => {
    let search = this.props.search;
    const selectedDates = dates ? dates : [];
    search.dates = selectedDates;
    this.props.doSearch(search);
    //this.setState({search});
  }
  handleBrandClick = (evt) => {
    const brandID = evt.target.id;
    let search = this.props.search
    search.brand = search.brand === brandID ? "" : brandID;
    this.props.doSearch(search);
    //this.setState({search});
  }
  handleViewClick = view => {
    this.setState({view});
    //console.log(this.state)
    this.props.handleViewChange(view);
  }
  render() {
    const { view } = this.state;
    const isEmpty = Object.values(this.props.search).every(x => (x === "" || typeof x === 'object')) && Object.values(this.props.search.filters).every(x => x === false);
    return (
      <div>
        <BrandSelection 
          user={this.props.user} 
          activeBrand={this.props.search.brand} 
          handleClick={this.handleBrandClick} 
          parentBrand={this.props.parentBrand}
        />
        <DebounceInput
          placeholder="Search for anything"
          id="searchInput"
          className="form-control"
          minLength={2}
          debounceTimeout={500}
          value={this.props.search.term}
          onChange={this.handleChange} />
        <div className="row mt-2">
          <div className="col-sm-6 col-md-3 col-lg-3 mb-2 mb-md-0">
            <CountryDropdrown
              value={this.props.search.country}
              handleSelect={this.handleSelectChange}
            />
          </div>
          <div className="col-sm-6 col-md-3 col-lg-3 mb-2 mb-md-0">
            <DateRangePicker
              value={this.props.search.dates}
              appearance="default"
              placeholder="Date range"
              onChange={this.handleDateChange}
              disabledDate={afterToday()}
              block
            />
          </div>
          <div className="col-sm-12 col-md-6 col-lg-6 d-flex align-items-center">
            <a onClick={() => this.handleViewClick("grid")} title="View gallery as a grid" className={`view-icon ${view === 'grid' ? 'active' : ''} `}>
              <img src={gridIcon} alt="4 squares forming a square grid" />
            </a>
            <a onClick={() => this.handleViewClick("list")} title="View gallery as a list" className={`view-icon ${view === 'list' ? 'active' : ''} `}>
              <img src={listIcon} alt="4 horizontal lines one on top of the other" />
            </a>
            { this.props.parentBrand == "monsterstrat" &&
              <a onClick={() => this.handleFilterChange("los")} title="View only Look Of Success images" className={`text-filter ${this.props.search.filters.los ? 'active' : ''}`}>
                <h3>LOS</h3>
              </a>
            }
            <a onClick={this.props.clearSearch} title="Clear all filters" className="ml-auto">
              <IconButton icon={<Icon icon="close" />} placement="left" size="xs" disabled={isEmpty} loading={this.props.isFetchingImages}>
                 Clear filters
              </IconButton>
            </a>

          </div>
        </div>
        <hr style={{ marginTop: '7px'}}></hr>
      </div>
    );
  }
}

const CountryDropdrown = ({ value, handleSelect, handleClean }) => {
  let [loading, setLoading] = useState(false);
  let [options, setOptions] = useState([]);
  const worksheetName = "Projects";

  const url = `https://sheets.googleapis.com/v4/spreadsheets/${process.env.REACT_APP_SPREADSHEET_ID}/values/${worksheetName}?key=${process.env.REACT_APP_GSHEET_KEY}`
  
  useEffect(() => {

    const fetchCountries = async () => { 
      setLoading(true);
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error("Network response was not OK in country fetch - search form");
        }
        const jsonData = await response.json();
        let countries = jsonData.values.slice(1);
        countries = countries.map(e => { 
          // Country string = 'Albania - AL'
          const stringParts = e[0].split(' - ')
          const name = stringParts[0]
          const code = stringParts[1]
          return {
            value: `${code} |-${code}-`,
            label: `${name}`
          };
        })
        setOptions(countries);
        setLoading(false);
      } catch(error) {
        console.error("There has been a problem with your countries fetch operation in search form:", error);
        setOptions([{value:' AF |-AF-', label: 'Afghanistan'},{value:' AL |-AL-', label: 'Albania'},{value:' DZ |-DZ-', label: 'Algeria'},{value:' AO |-AO-', label: 'Angola'},{value:' AT |-AT-', label: 'Austria'},{value:' AZ |-AZ-', label: 'Azerbaijan'},{value:' BH |-BH-', label: 'Bahrain'},{value:' BY |-BY-', label: 'Belarus'},{value:' BE |-BE-', label: 'Belgium'},{value:' BA |-BA-', label: 'Bosnia'},{value:' BG |-BG-', label: 'Bulgaria'},{value:' HR |-HR-', label: 'Croatia'},{value:' CY |-CY-', label: 'Cyprus'},{value:' CZ |-CZ-', label: 'Czech Republic'},{value:' DK |-DK-', label: 'Denmark'},{value:' EG |-EG-', label: 'Egypt'},{value:' EE |-EE-', label: 'Estonia'},{value:' ET |-ET-', label: 'Ethiopia'},{value:' EU |-EU-', label: 'EU'},{value:' FI |-FI-', label: 'Finland'},{value:' FR |-FR-', label: 'France'},{value:' GE |-GE-', label: 'Georgia'},{value:' DE |-DE-', label: 'Germany'},{value:' GB |-GB-', label: 'Great Britain'},{value:' GR |-GR-', label: 'Greece'},{value:' HU |-HU-', label: 'Hungary'},{value:' IS |-IS-', label: 'Iceland'},{value:' IE |-IE-', label: 'Ireland'},{value:' IT |-IT-', label: 'Italy'},{value:' IL |-IL-', label: 'Israel'},{value:' IC |-IC-', label: 'Ivory Coast'},{value:' JO |-JO-', label: 'Jordan'},{value:' KZ |-KZ-', label: 'Kazakhstan'},{value:' KE |-KE-', label: 'Kenya'},{value:' XK |-XK-', label: 'Kosovo'},{value:' KW |-KW-', label: 'Kuwait'},{value:' LV |-LV-', label: 'Latvia'},{value:' LT |-LT-', label: 'Lithuania'},{value:' LU |-LU-', label: 'Luxembourg'},{value:' MK |-MK-', label: 'Macedonia'},{value:' MG |-MG-', label: 'Madagascar'},{value:' MW |-MW-', label: 'Malawi'},{value:' MT |-MT-', label: 'Malta'},{value:' YT |-YT-', label: 'Mayotte'},{value:' MD |-MD-', label: 'Moldova'},{value:' MC |-MC-', label: 'Monaco'},{value:' ME |-ME-', label: 'Montenegro'},{value:' MA |-MA-', label: 'Morocco'},{value:' MZ |-MZ-', label: 'Mozambique'},{value:' MU |-MU-', label: 'Mauritius'},{value:' NA |-NA-', label: 'Namibia'},{value:' NL |-NL-', label: 'Netherlands'},{value:' NZ |-NZ-', label: 'New Zealand'},{value:' NG |-NG-', label: 'Nigeria'},{value:' Nightlife |-Nightlife-', label: 'Nightlife'},{value:' NO |-NO-', label: 'Norway'},{value:' OM |-OM-', label: 'Oman'},{value:' PK |-PK-', label: 'Pakistan'},{value:' PS |-PS-', label: 'Palestine'},{value:' PL |-PL-', label: 'Poland'},{value:' PT |-PT-', label: 'Portugal'},{value:' QA |-QA-', label: 'Qatar'},{value:' RE |-RE-', label: 'Reunion Island'},{value:' RO |-RO-', label: 'Romania'},{value:' RU |-RU-', label: 'Russia'},{value:' SA |-SA-', label: 'Saudi Arabia'},{value:' SN |-SN-', label: 'Senegal'},{value:' RS |-RS-', label: 'Serbia'},{value:' SIC |-SIC-', label: 'Sicily'},{value:' SK |-SK-', label: 'Slovakia'},{value:' SI |-SI-', label: 'Slovenia'},{value:' ZA |-ZA-', label: 'South Africa'},{value:' ES |-ES-', label: 'Spain'},{value:' SE |-SE-', label: 'Sweden'},{value:' CH |-CH-', label: 'Switzerland'},{value:' TZ |-TZ-', label: 'Tanzania'},{value:' TJ |-TJ-', label: 'Tajikistan'},{value:' TR |-TR-', label: 'Turkey'},{value:' AE |-AE-', label: 'UAE'},{value:' UG |-UG-', label: 'Uganda'},{value:' UA |-UA-', label: 'Ukraine'},{value:' US |-US-', label: 'USA'},{value:' ZM |-ZM-', label: 'Zambia'},{value:' ZW |-ZW-', label: 'Zimbabwe'}]);
        setLoading(false);
      }
    }
    fetchCountries();

    return () => {
      // component unmounted
    }
  }, [])

  return (
    <SelectPicker
      value={value}
      placeholder="Country"
      onChange={handleSelect}
      cleanable={true}
      data={options}
      loading={loading}
      block
    />
  )
}


class BrandSelection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      isFetching: false,
      brands: []
    }
  }

  componentDidMount() {
    this.fetchBrands();
  } 

  async fetchBrands() {
    this.setState({...this.state, isFetching: true});
    const snapshot = await imagebankRef.child(`brands_2022/`).orderByChild("parent").equalTo(this.props.parentBrand).once('value');
    if (snapshot.exists()) {
      const brandsObj = snapshot.val();
      const brandArray = Object.values(brandsObj);
      const brands = brandArray.filter((brand) => !brand.hidden);
      brands.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)); 
      this.setState({...this.state, brands, isFetching: false});
    } else {
      this.setState({...this.state, isFetching: false});
    }
    
  }

  saveBrand(brand) {
    let brands = this.state.brands;
    brands.map(obj => brand.id === obj.id ? brand : obj);
    this.setState({ ...this.state, brands })
    imagebankRef.child(`brands_2022/${brand.id}`).update(brand).then(() => {
      Alert.success('Data saved successfully.', 5000);
    }).catch((error) => {
      Alert.error(`Data save issue. ${error}`, 5000);
    });
  }

  addBrand(newBrand) {
    const newBrandRef = imagebankRef.child('brands').push();
    newBrand.id = newBrandRef.key;
    newBrandRef.set(newBrand).then(() => {
      Alert.success('Data saved successfully.', 5000);
      this.setState({ brands: [...this.state.brands, newBrand] })
    }).catch((error) => {
      Alert.error(`Data save issue. ${error}`, 5000);
    });
  }

  deleteBrand(id) {
    imagebankRef.child(`brands_2022/${id}`).remove().then(() => {
      Alert.success('Brand removed.', 3000);
      this.setState({ brands: this.state.brands.filter(element => element.id !== id)})
    }).catch((error) => {
      Alert.error(`Data removal issue. ${error}`, 3000);
    });
  }

  render() {
    const { brands } = this.state;
    const { user } = this.props;
    if(brands.length <= 1 && user?.role !== "admin") return null;
    return (
      <div className={`mb-3 d-flex w-100 flex-wrap flex-md-nowrap align-items-center justify-content-start`}>
        {brands.map((item, i) => (<BrandLogo image={item} handleClick={this.props.handleClick} activeBrand={this.props.activeBrand} index={i} key={i} />),
        this)}
        {this.props.user.role === 'admin' &&
          <BrandManager brands={this.state.brands} onUpdate={this.saveBrand.bind(this)} onAdd={this.addBrand.bind(this)} deleteBrand={this.deleteBrand.bind(this)} />
        }
        
      </div>
    )
  }
}


class BrandManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      isSaving: false,
      isUploading: '',
      uploadProgress: 0,
      isEditing: '',
      propEditing: '',
      addingNew: false,
      deleteCheck: ''
    };
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleTextClick = this.handleTextClick.bind(this);
    this.newBrand = this.newBrand.bind(this);
    this.deleteCheck = this.deleteCheck.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
  }

  componentDidMount() {
    this.setState({ ...this.state, brands: this.props.brands })
  }

  close() {
    this.setState({ show: false, isEditing: '', propEditing: '', deleteCheck: '' });
  }
  open(e) {
    e.preventDefault();
    this.setState({ show: true });
  }

  handleChange(property) {
    const brands = this.props.brands;
    const brandObj = brands.find(element => element.id === this.state.isEditing );
    const newValue = document.getElementById(`brandInput-${property}`).value;
    if(brandObj[property] !== newValue) {
      brandObj[property] = newValue;
      this.props.onUpdate(brandObj);
    }
    this.setState( { ...this.state, isEditing: '', propEditing: '' } )
  };
  
  handleImageUpload(event, name) {
    if(event.target.files.length === 0) return;
    this.setState({ ...this.state, isUploading: name, uploadProgress: 10 });
    let File = event.target.files[0];
    //let filename = file.name.split('.')[0];
    const fileRef = storageRef.child(`brands/${File.name}`);
    var uploadTask = fileRef.put(File);
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
      (snapshot) => {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        let uploadProgress = (snapshot.bytesTransferred / snapshot.totalBytes) * 95 + 10;
        this.setState({ ...this.state, uploadProgress });
      }, (error) => {
        Alert.error('Could not upload image.', 3000);
        console.log('Upload error');
      }, () => {
        // upload success
        this.setState({ ...this.state, uploadProgress: 100});
        fileRef.getDownloadURL().then((downloadURL) => {
          const brands = this.props.brands;
          const brandObj = brands.find(element => element.name === name);
          brandObj.logo = downloadURL;
          this.props.onUpdate(brandObj);
          this.setState({ ...this.state, isUploading: '' });
        })
      }
    );
  }

  handleTextClick(id, prop) {
    this.setState({ ...this.state, isEditing: id, propEditing: prop })
  }

  newBrand() {
    this.setState({ addingNew: true })
  }
  deleteCheck(id) {
    this.setState({ deleteCheck: id })
  }
  confirmDelete() {
    this.props.deleteBrand(this.state.deleteCheck);
    this.setState({ deleteCheck: '' })
  }

  render() {
    const { isEditing, propEditing, addingNew, deleteCheck } = this.state;
    return (
      <div className="">
        <IconButton className="ml-2" icon={<Icon icon="edit2" />} circle size="sm" onClick={this.open} />

        <Modal 
          full 
          size='lg' 
          show={this.state.show} 
          onHide={this.close} 
          onEntered={this.onEntered}
          overflow={true}
          >
          <Modal.Header>
            <Modal.Title>Imagebank Brands</Modal.Title>
            <p>Click image or text to edit</p>
          </Modal.Header>
          <Modal.Body>

            <List className="brandList" size="lg" style={{ width: '800px' }}>
              <FlexboxGrid >
                <FlexboxGrid.Item colspan={4}>
                  <p><strong>Logo</strong></p>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item colspan={8}>
                  <p><strong>Name</strong></p>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item colspan={6}>
                  <p><strong>Label / File code</strong></p>
                </FlexboxGrid.Item>
              </FlexboxGrid>

              {this.props.brands.map((item, index) => (
                <List.Item key={item['name']} index={index}>
                  <FlexboxGrid align="middle">
                    <FlexboxGrid.Item colspan={4}>
                      <label>
                        <img src={ item.logo } alt={`Logo for ${item.name}`} className="brandList-logo cursor-pointer" />
                        <input type="file" onInput={(e) => this.handleImageUpload(e, item.name)} accept="image/png, image/jpeg, image/svg+xml" style={{ display: 'none' }} /> 
                      </label>   
                      <div className="progress" style={{ height: '3px', backgroundColor: 'white' }}>
                        <div className="progress-bar" role="progressbar" style={{ width: this.state.isUploading === item.name ? this.state.uploadProgress+'%' : '0%' }} aria-valuenow={this.state.uploadProgress} aria-valuemin="0" aria-valuemax="100"></div>
                      </div>                  
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item colspan={8}>
                      {isEditing === item.id && propEditing === 'name' ?
                      (
                        <InputGroup style={{ width: '180px', margin: '0 auto' }}>
                          <Input defaultValue={item.name} id="brandInput-name" name="name" />
                          <InputGroup.Button onClick={() => this.handleChange('name')}>
                            <Icon icon="check" />
                          </InputGroup.Button>
                        </InputGroup>
                      ) : (
                        <p className="brandList-name cursor-pointer" onClick={() => this.handleTextClick(item.id, 'name')}>{ item.name }</p>
                      )}
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item colspan={6}>
                      {isEditing === item.id && propEditing === 'label' ?
                      (
                        <InputGroup style={{ width: '150px', margin: '0 auto' }}>
                          <Input defaultValue={item.label} id="brandInput-label" name="label" />
                          <InputGroup.Button onClick={() => this.handleChange('label')}>
                            <Icon icon="check" />
                          </InputGroup.Button>
                        </InputGroup>
                      ) : (
                        <p className="brandList-label cursor-pointer" onClick={() => this.handleTextClick(item.id, 'label')}>{ item.label }</p>
                      )}
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item colspan={3}>
                      { deleteCheck !== item.id ?
                        <IconButton icon={<Icon icon="trash-o" />} circle size="sm" onClick={() => this.deleteCheck(item.id)} />
                        :
                        <Button color="red" onClick={this.confirmDelete}>You sure?</Button>
                      }
                    </FlexboxGrid.Item>
                  </FlexboxGrid>
                </List.Item>
              ))}
              <List.Item key='newItem'>
                { addingNew ?
                (
                  <NewBrandForm  addBrand={this.props.onAdd} />
                ) : (
                  <IconButton className="mt-2 mx-auto" icon={<Icon icon="plus" />} circle size="sm" onClick={this.newBrand} />
                )}
              </List.Item>

            </List>
          
          </Modal.Body>
          <Modal.Footer>
            {this.state.isSaving &&
              <p className="d-inline">Data saving...</p>
            }
            <Button className="ml-5" onClick={this.close} appearance="subtle">
              Close
            </Button>
          </Modal.Footer>
        </Modal>

      </div>
    )
  }
}

const BrandLogo = ({ image, index, activeBrand, handleClick }) => {
  return (
    <div className={``}>
      <img 
        src={image.logo} 
        className={`brand-logo ${activeBrand === image.label ? 'active' : ''} `} 
        id={image.label} 
        title={image.name} 
        alt={`Logo for ${image.name}`}
        onClick={handleClick} />
    </div>
  )
}
